module.exports = __webpack_public_path__ + "static/media/Telus_One_page-08.4279e567.png";